module.exports = __webpack_public_path__ + "3ccef8380168c22097d6004196980eb8.woff";